export const environment = {
  production: true,
  raygunKey: "3YqyxlDiJJgOYOn8WBpdQ",
  apiUrl: "https://cmsapp.moveinsync.com/propmanagement",
  redirectUri: "https://cmsapp.moveinsync.com/callback",
  googleRequestForm:
    "https://docs.google.com/forms/d/e/1FAIpQLSfXKxzMB79247l5p0BvTdL8NUtTt4FNtIv1jnPw6H4YJCbX8A/viewform?usp=pp_url&entry.1735820221=prod",
  googleRequestSheets:
    "https://docs.google.com/spreadsheets/d/1LGFz1_6pwY4b6FV4JGkWSJrxKEw9oqx7XxoCeBNWaXo/edit?usp=sharing",
};
